import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import '../../assets/css/styles.css'
import Config from '../../commons/config/Config.js';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import FormValidation from '../../commons/validation/FormValidation.js'
import Validator from '../../commons/validation/Validator.js'
import Loading from '../ui/Loading.js'
import swal from 'sweetalert'
import {FormattedMessage, injectIntl} from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';
import Notificacion from '../app/Notificacion.js';

// --- DEVOPS FIX: DICCIONARIO DE EMERGENCIA ---
const FALLBACK_MESSAGES = {
    'login.errors.invalido': { id: 'login.errors.invalido', defaultMessage: 'Usuario o contraseña incorrectos.' },
    'login.errors.activar_cuenta': { id: 'login.errors.activar_cuenta', defaultMessage: 'Su usuario se encuentra inactivo. Contacte al administrador.' },
    'login.errors.No_se_encontro_numero_de_telefono_asociado_a_su_usuario': { id: 'login.errors.no_phone', defaultMessage: 'No se encontró un celular asociado para 2FA.' },
    'authService.errors.contrasenia_debe_tener_una_longitud_entre': { id: 'auth.pass.len', defaultMessage: 'La contraseña debe tener entre 8 y 16 caracteres.' },
    'errors.internal_server_error': { id: 'error.500', defaultMessage: 'Error interno del servidor.' }
};

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: { usuario: null, clave: null },
            errors:[],
            loading: false,
            redirectTo: null,
            loginEnabled : ConfigBusiness.get("frontend.loginInstancia.habilitado"),
            mantenimientoEnabled: ConfigBusiness.get("frontend.mantenimiento.habilitado"),
            mantenimientoMensaje: (ConfigBusiness.get("frontend.mantenimiento.mensaje") || props.intl.formatMessage({id: 'login.mantenimiento.mensaje_default', defaultMessage: "Estamos realizando mejoras en el sistema.\nVolveremos a estar operativos a la brevedad."})).split('\n'),
            mantenimientoFechaFin: ConfigBusiness.get("frontend.mantenimiento.fechaFin"),
            mantenimientoCountdown: null,
            loginServices: {},
            azureLoginRedirect: Config.get('apiUrlBase') + '/public/auth/azure/redirect',
            googleLoginRedirect: Config.get('apiUrlBase') + '/public/auth/google/redirect',
            loadingLogoLogin: true,
            logoLoginUrl: null, 
            languages:[],
            languagesExtra: {
                "es": props.intl.formatMessage({id: 'login.languages.español', defaultMessage: 'Español'}),
                "en": props.intl.formatMessage({id: 'login.languages.ingles', defaultMessage: 'Inglés'})
            },
            showVersionFull: false,
            configError: false,
            retryCountdown: 60,
            isLegacyDomain: false,
            countdown: 10
        }

        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleForgotPassword = this.handleForgotPassword.bind(this);
        this.loginRandom = null;
        this.changeLocale = this.changeLocale.bind(this);
        this.maintenanceInterval = null;
        this.statusCheckInterval = null;
        this.retryInterval = null;
        this.redirectInterval = null;
    }

    // --- DEVOPS FIX: ARQUITECTURA DE MARCA BLANCA (CARPETAS) ---
    getBrandedLogo(defaultFilename, visibilityConfigKey = null) {
        if (visibilityConfigKey) {
            const isVisible = ConfigBusiness.get(visibilityConfigKey);
            if (isVisible === "false") return null;
        }
        const clientSlug = ConfigBusiness.get("generales.clienteSlug");
        if (clientSlug && clientSlug !== "false" && clientSlug !== "default") {
            return `${process.env.PUBLIC_URL}/images/branding/${clientSlug}/${defaultFilename}`;
        }
        return `${process.env.PUBLIC_URL}/images/company/${defaultFilename}`;
    }

    updateCountdown = () => {
        if (!this.state.mantenimientoFechaFin) return;
        const distancia = new Date(this.state.mantenimientoFechaFin).getTime() - new Date().getTime();
        if (distancia < 0) {
            this.setState({ mantenimientoCountdown: this.props.intl.formatMessage({id: 'login.mantenimiento.finalizando', defaultMessage: "Finalizando tareas..."}) });
            return;
        }
        const horas = Math.floor((distancia % (86400000)) / 3600000);
        const minutos = Math.floor((distancia % 3600000) / 60000);
        const segundos = Math.floor((distancia % 60000) / 1000);
        this.setState({ mantenimientoCountdown: `${horas}h ${minutos}m ${segundos}s` });
    }

    checkMaintenanceStatus = () => {
        const timestamp = new Date().getTime();
        const checkUrl = Config.get('apiUrlBase') + '/public/auth/services?t=' + timestamp;
        fetch(checkUrl, { method: 'GET' }).then(res => {
            if(res.status === 200) {
               res.json().then(data => {
                   if(this.state.mantenimientoFechaFin && new Date() > new Date(this.state.mantenimientoFechaFin)){
                       window.location.reload();
                   }
               });
            }
        }).catch(err => {});
    }

    startRetryCountdown = () => {
        if(this.retryInterval) clearInterval(this.retryInterval);
        this.setState({ retryCountdown: 60 });
        this.retryInterval = setInterval(() => {
            this.setState((prevState) => {
                if (prevState.retryCountdown <= 1) {
                    clearInterval(this.retryInterval);
                    window.location.reload();
                    return { retryCountdown: 0 };
                }
                return { retryCountdown: prevState.retryCountdown - 1 };
            });
        }, 1000);
    }

    componentWillMount () {
        this.formValidation = new FormValidation({
            component: this,
            validators: {
                'formData.usuario': (value) => Validator.notEmpty(value),
                'formData.clave': (value) => Validator.notEmpty(value)
            }
        });

        // Intentamos buscar el logo falopa subido por la API
        fetch(Config.get('apiUrlBase') + '/public/contextos_imagenes/logoLogin', {
            method: 'GET',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        }).then(response => {
            let contentType = response.headers.get('Content-Type');
            if (contentType && contentType.startsWith('image/')) return response.blob();
            throw new Error('No es imagen');
        }).then(blob => {
            this.setState({ logoLoginUrl: URL.createObjectURL(blob) });
        }).catch(() => {
            // Falla silenciosa, usamos carpeta branding
        }).finally(() => {
            this.setState({ loadingLogoLogin: false });
        });
    }

    componentDidMount () {
        document.body.className = 'vertical-layout vertical-menu 1-column menu-expanded blank-page blank-page';
        document.body.setAttribute('data-col', '1-column');

        const hostname = window.location.hostname;
        const isOldProd = (hostname === 'telecom.vec.com.ar' || hostname === 'telecom.vecfleet.io');
        const isOldTest = (hostname === 'testing-teco.vec.com.ar');

        if (this.state.mantenimientoEnabled === "true") {
            if (this.state.mantenimientoFechaFin) {
                this.updateCountdown();
                this.maintenanceInterval = setInterval(this.updateCountdown, 1000);
            }
            this.statusCheckInterval = setInterval(this.checkMaintenanceStatus, 30000);
        }

        if (isOldProd || isOldTest) {
            const target = isOldProd ? 'https://personal.vecfleet.io' : 'https://personal-test.vecfleet.io';
            this.setState({ isLegacyDomain: true, targetUrl: target });
            this.redirectInterval = setInterval(() => {
                this.setState((prevState) => {
                    if (prevState.countdown <= 1) {
                        clearInterval(this.redirectInterval);
                        window.location.replace(target);
                        return { countdown: 0 };
                    }
                    return { countdown: prevState.countdown - 1 };
                });
            }, 1000);
        }

        fetch(Config.get('apiUrlBase') + '/public/auth/services', {
            method: 'GET',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        }).then(response => {
            if(response.status === 200) {
                response.json().then(data => { this.setState({ loginServices: data }) });
            } else {
                this.setState({ configError: true });
                this.startRetryCountdown();
            }
        }).catch(() => {
            this.setState({ configError: true });
            this.startRetryCountdown();
        }).finally(() => {
            this.setState({ loading: false });
            if (this.state.loginServices && (this.state.loginServices.classic === 'true' || this.state.loginServices.classic === true) && this.state.mantenimientoEnabled !== "true") {
                if(this.refs.usuario) this.refs.usuario.focus();
            }
        });

        let lang = ConfigBusiness.get("frontend.multilenguaje");
        try {
            const langJson = JSON.parse(lang);
            if (langJson) {
                this.setState({
                    languages: langJson.map(elem => {
                        elem.title = this.state.languagesExtra[elem.lang];
                        return elem;
                    })
                });
            }
        } catch(e) {}
    }

    componentWillUnmount() {
        if (this.redirectInterval) clearInterval(this.redirectInterval);
        if (this.maintenanceInterval) clearInterval(this.maintenanceInterval);
        if (this.statusCheckInterval) clearInterval(this.statusCheckInterval);
        if (this.retryInterval) clearInterval(this.retryInterval);
    }

    handleFormChange(event) {
        const target = event.target;
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy[target.name] = target.value;
        this.setState({ formData: formDataCopy });
    }

    handleSubmit(event) {
        this.setState({ loading: true, errors:[] });
        fetch(Config.get('apiUrlBase') + '/public/auth/login', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...this.state.formData }),
        }).then(response => {
            if(response.status === 200) {
                response.json().then(data => {
                    if(data && data.usuario && data.usuario.token) {
                        localStorage.setItem('persona', JSON.stringify(data));
                        localStorage.setItem('token', data.usuario.token);
                        localStorage.setItem('cerrarNotificacion', false);
                        if (data.usuario.enable_twofa && ConfigBusiness.get("2fa.habilitado") == "true") {
                            if(!data.celularCodArea || !data.celularNumero){
                                swal({
                                    title: this.props.intl.formatMessage({ id: 'login.errors.Contacte_al_administrador', defaultMessage: 'Contacte al administrador' }),
                                    text: this.props.intl.formatMessage({...(backendStrings['login.errors.No_se_encontro_numero_de_telefono_asociado_a_su_usuario'] ? backendStrings['login.errors.No_se_encontro_numero_de_telefono_asociado_a_su_usuario'] : backendStrings['errors.default']) }),
                                    icon: "error",
                                    buttons: { confirm: { text: "Aceptar", className: "btn btn-primary", closeModal: true } }
                                });
                            }else{
                                this.setState({ redirectTo: '/auth/2fa' })
                            }
                        } else {
                            window.location.reload();
                        }
                    } else {
                        this.error();
                    }
                });
            } else if(response.status === 401) {
                response.json().then(data => {
                    let msgs = data.detalle ||['login.errors.invalido'];
                    this.setState({ errors: msgs });
                }).catch(() => {
                    this.setState({ errors: ['login.errors.invalido'] });
                });
            } else if(response.status === 400 || response.status === 403) {
                response.json().then(data => {
                    const msgKey = (data.detalle && data.detalle[0]) ? data.detalle[0] : 'errors.default';
                    swal({
                        title: this.props.intl.formatMessage({ id: 'login.errors.Contacte_al_administrador', defaultMessage: 'Contacte al administrador' }),
                        text: this.props.intl.formatMessage({...(backendStrings[msgKey] ? backendStrings[msgKey] : {id: msgKey, defaultMessage: data.message || msgKey}) }),
                        icon: "error",
                        buttons: { confirm: { text: "Aceptar", className: "btn btn-primary", closeModal: true } }
                    });
                });
            } else {
                this.error();
            }
        }).catch(() => {
            this.error("Problema de conexión con el servidor.");
        }).finally(() => {
            this.setState({ loading: false });
        });

        event.preventDefault();
    }

    handleForgotPassword(e) { this.setState({ redirectTo: '/olvide-clave' }); e.preventDefault(); }
    changeLocale(locale) { localStorage.setItem('userLocale', locale); window.location.reload(); }

    error(customMsg = null) {
        swal({
            title: this.props.intl.formatMessage({ id: 'login.errors.swal.title', defaultMessage: 'Error interno del sistema.' }),
            text: customMsg || this.props.intl.formatMessage({ id: 'login.errors.swal.text', defaultMessage: 'Contacte al administrador.' }),
            icon: "error",
            buttons: { confirm: { text: "Aceptar", value: true, visible: true, className: "btn btn-primary", closeModal: true } }
        });
    }

    render() {
        this.formValidation.validate();
        let validationState = this.formValidation.state;
        if(!this.loginRandom) this.loginRandom = 1 + Math.floor((4 - 1) * Math.random());

        // --- DEVOPS LOGIC: OBTENCIÓN DE LOGOS (Con Fallbacks Integrados) ---
        const logoAppSrc = this.state.logoLoginUrl || this.getBrandedLogo("logo-login-app.png");
        const logoCompanySrc = this.getBrandedLogo("logo-login-company.png", "frontend.logos.company.visible");
        const logoPoweredBySrc = this.getBrandedLogo("logo-login-powered-by.png", "frontend.logos.poweredBy.visible");
        
        const versionLabel = process.env.REACT_APP_VERSION || "0.0.0";
        const isVersionLong = versionLabel.length > 10;

        const deadlineDate = new Date('2026-01-08T00:00:00');
        const dateText = new Date() > deadlineDate ? "Esta plataforma dejará de estar operativa próximamente." : "Esta plataforma dejará de estar operativa el 08/01/2026.";

        return (
            <React.Fragment>
                {ConfigBusiness.get("generales.alertaSuspension")==='true' && (
                    <Notificacion closeable={false} title={this.props.intl.formatMessage({ id: 'layout.Alerta_de_suspension_por_falta_de_pago', defaultMessage: 'Alerta de suspensión por falta de pago' })} message={this.props.intl.formatMessage({ id: 'layout.Tu_cuenta_tiene_un_pago_pendiente', defaultMessage: 'Tu cuenta tiene un pago pendiente. Por favor regularice la situación.' })} top="0" />
                )}
                {this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
                {this.state.loading && <Loading hideSpinner />}
                
                <div className="app-content content">
                    <div className="content-wrapper">
                        <div className="content-header row"></div>
                        <div className="content-body">
                            
                            <video className="video-login-bg" autoPlay muted loop poster={process.env.PUBLIC_URL + "/images/images-login/image"+ this.loginRandom +".png"}>
                                <source src={process.env.PUBLIC_URL + "/images/videos-login/video"+ this.loginRandom +".mp4"} type="video/mp4"/>
                            </video>
                            
                            <section className="flexbox-container">
                                <div className="col-12 d-flex align-items-center justify-content-center">
                                    <div className="col-md-4 col-10 p-0">
                                        <div className="card border-0 m-0" style={{borderRadius: '1rem', boxShadow: '0 10px 25px rgba(0,0,0,0.3)', position: 'relative'}}>
                                            
                                            <div id="loginLogo" className="card-header border-0 text-center" style={{padding: '1.5rem 1.5rem 0'}}>
                                                {!this.state.loadingLogoLogin && 
                                                    <img 
                                                        src={logoAppSrc} 
                                                        alt="App Logo" 
                                                        className="img-fluid center-block" 
                                                        style={{ maxHeight: '130px', objectFit: 'contain' }} 
                                                        onError={(e) => { e.target.onerror = null; e.target.src = process.env.PUBLIC_URL + "/images/company/logo-login-app.png"; }}
                                                    />
                                                }
                                            </div>
                                            
                                            <div className="card-body" style={{padding: '1.5rem'}}>
                                                {this.state.configError ? (
                                                    <div className="text-center py-2 px-1">
                                                        <div className="mb-2"><i className="la la-exclamation-triangle" style={{ fontSize: '50px', color: '#dc3545' }}></i></div>
                                                        <h4 className="mb-2 text-danger font-weight-bold">Problemas de Conexión</h4>
                                                        <p className="text-muted">No se pudo establecer comunicación con el servidor.<br/>Estamos intentando reconectar.</p>
                                                        <div className="mt-3"><div className="progress mb-2" style={{height: '5px', borderRadius:'5px'}}><div className="progress-bar bg-danger" role="progressbar" style={{width: (this.state.retryCountdown / 60 * 100) + '%'}}></div></div><small className="text-muted">Reintentando en {this.state.retryCountdown}s...</small></div>
                                                        <button className="btn btn-outline-danger btn-block mt-3" onClick={() => window.location.reload()} style={{borderRadius: '8px'}}><i className="la la-refresh"></i> Reintentar Ahora</button>
                                                    </div>
                                                ) : this.state.mantenimientoEnabled === "true" ? (
                                                    <div className="text-center py-2 px-1">
                                                        <div className="mb-2"><i className="la la-cog spinner text-warning" style={{ fontSize: '50px' }}></i></div>
                                                        <h3 className="mb-2" style={{ fontWeight: 'bold' }}><FormattedMessage id="login.mantenimiento.titulo" defaultMessage="Plataforma en Mantenimiento" /></h3>
                                                        <div className="alert alert-warning border-warning" role="alert" style={{borderRadius: '8px'}}>{this.state.mantenimientoMensaje.map((linea, idx) => (<p key={idx} className="mb-0" style={{fontSize: '14px'}}>{linea}</p>))}</div>
                                                        {this.state.mantenimientoCountdown && (<div className="mt-2"><p className="text-muted font-small-3 mb-0">Tiempo estimado restante:</p><span className="badge badge-secondary p-2 mt-1" style={{fontSize: '16px', fontFamily: 'monospace', borderRadius: '8px'}}><i className="la la-clock-o"></i> {this.state.mantenimientoCountdown}</span></div>)}
                                                    </div>
                                                ) : (
                                                    <React.Fragment>
                                                        {this.state.isLegacyDomain ? (
                                                            <div className="text-center py-2 px-1">
                                                                <h3 className="mb-2" style={{color: '#0033A0', fontWeight: 'bold'}}>¡Nos estamos mudando!</h3>
                                                                <div className="alert alert-info border-info" style={{borderRadius: '8px'}} role="alert"><p className="mb-1">Estamos renovando nuestra imagen para brindarte una mejor experiencia.</p><hr className="my-1"/><p className="font-weight-bold mb-0">{dateText}</p></div>
                                                                <div className="mb-2"><small>Redirigiendo automáticamente en <strong>{this.state.countdown}</strong>s...</small></div>
                                                                <button className="btn btn-success btn-lg btn-block shadow-sm" style={{borderRadius: '8px'}} onClick={() => window.location.href = this.state.targetUrl}>Ir al nuevo sitio <i className="la la-arrow-right"></i></button>
                                                            </div>
                                                        ) : (
                                                            <div className="login-normal-flow">
                                                                {this.state.loginEnabled === "false" ? (
                                                                    <div className="text-center py-2">
                                                                        <h3 className="text-muted">La plataforma no se encuentra disponible.</h3>
                                                                        <span className="text-muted">Por favor, contacte a su Ejecutivo de Cuentas.</span>
                                                                    </div>
                                                                ) : (
                                                                    <React.Fragment>
                                                                        {(this.state.loginServices.classic === 'true' || this.state.loginServices.classic === true) &&
                                                                            <form className="form-horizontal" noValidate ref="form" onSubmit={this.handleSubmit}>
                                                                                <p id="loginSubtitle" className="card-subtitle line-on-side text-muted text-center font-small-3 mb-2"></p>
                                                                                <fieldset className="form-group position-relative has-icon-left">
                                                                                    <input type="text" className="form-control form-control-lg input-lg" style={{borderRadius: '8px'}} id="usuario" name="usuario" ref="usuario" placeholder={this.props.intl.formatMessage({ id: 'login.usuario.placeholder', defaultMessage: 'Usuario' })} tabIndex="1" required="" onChange={this.handleFormChange} />
                                                                                    <div className="form-control-position"><i className="la la-user"></i></div>
                                                                                    <div className="help-block text-danger font-small-3" hidden={validationState.formData.usuario.pristine || validationState.formData.usuario.valid}>{validationState.formData.usuario.message}</div>
                                                                                </fieldset>
                                                                                <fieldset className="form-group position-relative has-icon-left">
                                                                                    <input type="password" className="form-control form-control-lg input-lg" style={{borderRadius: '8px'}} id="clave" name="clave" placeholder={this.props.intl.formatMessage({ id: 'login.contraseña.placeholder', defaultMessage: 'Contraseña' })} tabIndex="2" required onChange={this.handleFormChange} />
                                                                                    <div className="form-control-position"><i className="la la-key"></i></div>
                                                                                    <div className="help-block text-danger font-small-3" hidden={validationState.formData.clave.pristine || validationState.formData.clave.valid}>{validationState.formData.clave.message}</div>
                                                                                </fieldset>
                                                                                <div className="form-group row mb-1">
                                                                                    <div className="col-12 text-right">
                                                                                        <button type="button" className="btn btn-link p-0 text-muted" style={{fontSize: '13px'}} onClick={e => this.handleForgotPassword(e)}>
                                                                                            <i className="ft-unlock"></i> <FormattedMessage id="login.contraseña.olvido" defaultMessage="¿Olvidó su contraseña?"/>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                                
                                                                                <div className="alert alert-danger p-1" style={{borderRadius: '8px', fontSize: '13px'}} role="alert" hidden={this.state.errors.length===0}>
                                                                                    <ul className="mb-0 pl-3">
                                                                                    {this.state.errors.map((e, i) => {
                                                                                        let msg = backendStrings[e];
                                                                                        if (!msg) msg = FALLBACK_MESSAGES[e];
                                                                                        if (!msg) msg = backendStrings['errors.default'] || { id: 'error.generic', defaultMessage: e };
                                                                                        return <li key={i}><FormattedMessage {...msg}/></li>
                                                                                    })}
                                                                                    </ul>
                                                                                </div>
                                                                                
                                                                                <button type="submit" className="btn btn-primary btn-lg btn-block shadow-sm" style={{borderRadius: '8px'}} disabled={!validationState.form.valid}>
                                                                                    <i className={this.state.loading ? 'la la-spinner spinner' : 'la la-lock'}></i> <FormattedMessage id="login.ingresar" defaultMessage="Ingresar"/>
                                                                                </button>
                                                                            </form>
                                                                        }

                                                                        {(this.state.loginServices.google === 'true' || this.state.loginServices.google === true) && 
                                                                            <div className="mt-2">
                                                                                <a href={this.state.googleLoginRedirect} className="btn btn-block bg-white border shadow-sm d-flex align-items-center justify-content-center" style={{borderRadius: '8px', height: '45px', color: '#555', textDecoration:'none'}}>
                                                                                    <img style={{width: '24px', marginRight: '10px'}} src={process.env.PUBLIC_URL + "/images/google.svg"} alt="G"/>
                                                                                    <span className="font-weight-bold"><FormattedMessage id="login.google" defaultMessage="Ingresar con Google" /></span>
                                                                                </a>
                                                                            </div>
                                                                        }
                                                                        {(this.state.loginServices.azure === 'true' || this.state.loginServices.azure === true) && 
                                                                            <div className="mt-2">
                                                                                <a href={this.state.azureLoginRedirect} className="btn btn-block bg-white border shadow-sm d-flex align-items-center justify-content-center" style={{borderRadius: '8px', height: '45px', color: '#555', textDecoration:'none'}}>
                                                                                    <img style={{width: '24px', marginRight: '10px'}} src={process.env.PUBLIC_URL + "/images/microsoft.svg"} alt="MS"/>
                                                                                    <span className="font-weight-bold"><FormattedMessage id="login.microsoft" defaultMessage="Ingresar con Microsoft" /></span>
                                                                                </a>
                                                                            </div>
                                                                        }
                                                                    </React.Fragment>
                                                                )}
                                                            </div>
                                                        )}
                                                    </React.Fragment>
                                                )}

                                                <div className="row mt-4 align-items-center">
                                                    <div className="col-6 text-left">
                                                        {logoCompanySrc && <img src={logoCompanySrc} alt="Company" className="img-fluid" style={{maxHeight: '45px', maxWidth: '200px', objectFit:'contain'}} onError={(e) => { e.target.onerror = null; e.target.src = process.env.PUBLIC_URL + "/images/company/logo-login-company.png"; }} />}
                                                    </div>
                                                    <div className="col-6 text-right">
                                                        {logoPoweredBySrc && <img src={logoPoweredBySrc} alt="Powered By" className="img-fluid" style={{maxHeight: '45px', maxWidth: '200px', objectFit:'contain'}} onError={(e) => { e.target.onerror = null; e.target.src = process.env.PUBLIC_URL + "/images/company/logo-login-powered-by.png"; }} />}
                                                    </div>
                                                </div>

                                                <div className="text-center mt-3">
                                                    <div className="d-flex justify-content-center align-items-center mb-1">
                                                        {this.state.languages.map((elem,index,arr) => (
                                                            <React.Fragment key={index}>
                                                                <span onClick={e => this.changeLocale(elem.lang)} className="cursor-pointer mx-1" title={elem.title}>
                                                                    <img className="flag-multilang" src={process.env.PUBLIC_URL + "/images/flags/" + elem.code + ".svg"} alt={elem.code} style={{width: '22px', borderRadius:'2px'}}/>
                                                                </span>
                                                                {index < arr.length-1 && <span className="text-muted">|</span>}
                                                            </React.Fragment>
                                                        ))}
                                                    </div>
                                                    
                                                    <div className="version-info d-flex flex-column align-items-center">
                                                        {isVersionLong ? (
                                                            <React.Fragment>
                                                                <button type="button" className="btn btn-sm btn-link text-muted p-0 m-0" style={{ fontSize: '11px', textDecoration: 'none' }} onClick={() => this.setState({ showVersionFull: !this.state.showVersionFull })}>
                                                                    Versión {this.state.showVersionFull ? '▲' : '▼'}
                                                                </button>
                                                                {this.state.showVersionFull && <div className="badge badge-light text-muted p-1 mt-1 border" style={{fontWeight:'normal'}}>{versionLabel}</div>}
                                                            </React.Fragment>
                                                        ) : (
                                                            <small className="text-muted" style={{ fontSize: '11px' }}>v{versionLabel}</small>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* ESCOBITA DEVOPS */}
                                                <div style={{ position: 'absolute', bottom: '15px', right: '15px', opacity: 0.4, transition: 'opacity 0.2s', cursor: 'pointer' }}
                                                     onMouseEnter={(e) => e.currentTarget.style.opacity = 1}
                                                     onMouseLeave={(e) => e.currentTarget.style.opacity = 0.4}>
                                                    <a href="/salir" title={this.props.intl.formatMessage({id: 'login.clear_cache', defaultMessage: 'Limpiar Caché'})}>
                                                        <i className="la la-broom" style={{ fontSize: '20px', color: '#999' }}></i>
                                                    </a>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default injectIntl(Login);
